import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var ArrowChevronLeft = function ArrowChevronLeft(props) {
  return React.createElement(SvgIcon, __assign({}, props), React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.00195 8.00293L10.0029 10.9971C10.0029 11.3708 9.89811 11.626 9.68848 11.7627C9.47884 11.8994 9.28288 11.9792 9.10059 12.002H8.99805L4.99902 8.00293L8.99805 3.99707H9.10059C9.46517 4.02897 9.72721 4.20215 9.88672 4.5166C9.96419 4.63965 10.0029 4.80143 10.0029 5.00195L7.00195 8.00293Z",
    clipRule: "evenodd"
  })));
};